import React from "react"
import LineProcessing2 from '../../base/LineProcessing2'

const renderLineProcessing2 = ({ field }) => {
	const { value, styles } = field || {}

	return <div className='t-form-lineprocessing2'><LineProcessing2 {...{ value, styles }} /></div>
}

export default renderLineProcessing2